/**
 * OnboardingStepHeader.tsx - Reusable header for onboarding steps
 * Displays a title and subtitle with consistent styling across all steps
 */
import React from "react";
import { View } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { colors, spacing, textColorStyles } from "../../../../styles/design-system";

export interface OnboardingStepHeaderProps {
  titleKey: string;
  subtitleKey: string;
}

function OnboardingStepHeader({ titleKey, subtitleKey }: OnboardingStepHeaderProps) {
  return (
    <View style={{ marginBottom: spacing.lg }}>
      <CustomText
        text={titleKey}
        size="xl"
        weight="bold"
        style={{ color: colors.grey[900], marginBottom: spacing.xs }}
      />
      <CustomText text={subtitleKey} size="m" style={[textColorStyles.textLight, { lineHeight: 1.2 * 26 }]} />
    </View>
  );
}

export default OnboardingStepHeader;
